import { Button } from 'src/components/atoms'
import { footerContacts } from 'src/lib'
import { Link } from 'react-router-dom'
import { Right } from 'src/assets'
import { t } from 'i18next'

const MobileFooter = () => (
  <div className='w-full bg-center bg-no-repeat bg-cover bg-forest2 flex-column'>
    <div className='w-full h-2/3 box-border px-[20px] py-[100px] flex-column justify-center items-center text-center gap-[30px]'>
      <div className='text-white w-full text-[30px] text-bold '>
        {t('footer.title')}
      </div>
      <div className='text-white w-full text-[20px]'>
        {t('footer.subtitle')}
      </div>
      <Button size='m' icon={<Right />}>
        {t('global.get.started')}
      </Button>
    </div>
    <div className='w-full p-[20px] flex h-[150px] justify-around gap-[10px] border-t border-dark-gray backdrop-blur-[3px]'>
      <div className='h-full flex-center text-white'>
        All rights reserved Travel © 2024 Cookies policy Terms & Conditions
      </div>

      <div className='flex gap-[10px] flex-center'>
        {footerContacts.map(({ to, icon: Icon }) => (
          <Link key={to} to={to}>
            <Icon />
          </Link>
        ))}
      </div>
    </div>
  </div>
)

export default MobileFooter
